<template>
  <div class="d-flex flex-column gap">
    <div v-if="has_pack">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-routes" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Packs de courses</div>
      </div>
      <div v-for="pack in inscription.list_packs_courses.list" :key="pack.id">
        <CartPackCourseItem v-if="pack.selected" :item="pack"></CartPackCourseItem>
      </div>
    </div>
    <div v-if="has_parcours_not_in_pack">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-routes" color="primary" size="small"></v-icon>
        <div class="font-weight-bold"><span v-if="!mainStore.parcours_billetterie_mode">Parcours</span><span
            v-else>Poste</span></div>
      </div>
      <div v-for="course in inscription.list_courses.list" :key="course.id">
        <CartCourseItem v-if="course.selected && is_not_in_selected_pack(course.id)" :item="course"></CartCourseItem>
      </div>
    </div>
    <div v-if="!has_pack && !has_parcours_not_in_pack">
      <div class="text-body-2" v-if="mainStore.is_default_mode">Cet inscrit ne
        participe à aucune course</div>
    </div>

    <div v-if="has_gia">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-shield-account" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">GIA</div>
      </div>
      <div class="d-flex justify-space-between align-top sm-gap">
        <div>
          <div class="text-body-1">Garantie individuelle d'annulation</div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="item.gia.prix">{{ item.gia.prix }}€</span><span v-else>-</span>
        </div>
      </div>

    </div>
    <div v-if="has_alerte_sms">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-message-processing-outline" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Suivi SMS</div>
      </div>
      <div class="d-flex justify-space-between align-top sm-gap">
        <div>
          <div class="text-body-1">Alerte de suivi par SMS</div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="item.alerte_sms.prix">{{ item.alerte_sms.prix }}€</span><span v-else>-</span>
        </div>
      </div>
    </div>

    <div v-if="has_donation">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-gift" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Donation</div>
      </div>
      <div class="d-flex justify-space-between align-top sm-gap">
        <div>
          <div class="text-body-1">Don {{ item.donation.beneficiaire }}</div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="item.donation.montant">{{ item.donation.montant }}€</span><span v-else>-</span>
        </div>
      </div>
    </div>
    <div v-if="has_options">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-star-plus" color="primary" size="small"></v-icon>
        <div class="font-weight-bold"><span v-if="!mainStore.billetterie_mode">Options</span><span
            v-else>Billetterie</span></div>
      </div>
      <div v-for="option in inscription.list_options.list" :key="option.id">
        <CartOptionItem v-if="option.quantite_souhaite > 0" :item="option"></CartOptionItem>
      </div>
    </div>

    <div v-if="has_activites">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-hiking" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Activités</div>
      </div>

      <div v-for="activite in inscription.list_activites.list" :key="activite.id">
        <CartActiviteItem v-if="activite.quantite_souhaite > 0" :item="activite"></CartActiviteItem>
      </div>
    </div>
    <div v-if="has_articles">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-shopping" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Articles</div>
      </div>
      <div v-for="article in inscription.list_articles.list" :key="article.id">
        <CartArticleItem v-if="article.quantite_souhaite > 0" :item="article"></CartArticleItem>
      </div>
      <CartLivraison :infos="inscription.list_articles.infos_livraison"></CartLivraison>
    </div>

    <div v-if="has_frais_bourse_dossard">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-cash-multiple" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Frais</div>
      </div>
      <div class="d-flex justify-space-between align-top sm-gap">
        <div>
          <div class="text-body-1">Frais de rachat</div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="item.frais_bourse_dossard.prix">{{ item.frais_bourse_dossard.prix }}€</span><span v-else>-</span>
        </div>

      </div>
    </div>
    <div v-if="has_remboursement">
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-cash-refund" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Crédit</div>
      </div>
      <div class="d-flex justify-space-between align-top sm-gap">
        <div>
          <div class="text-body-1">Remboursement parcours initial</div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="has_remboursement">-{{ has_remboursement }}€</span><span v-else>-</span>
        </div>
      </div>
    </div>
    <div v-if="!inscription.code_reduction" class="d-flex justify-end">
      <v-btn prepend-icon="mdi-ticket-percent" density="compact" class="pa-0 px-1 no-uppercase" variant="text"
        @click="openDialogCodeReduction()">J'ai un
        code de
        réduction ?</v-btn>
    </div>
    <div v-else>
      <div class="d-flex justify-start align-center sm-gap flex-nowrap">
        <v-icon icon="mdi-ticket-percent" color="primary" size="small"></v-icon>
        <div class="font-weight-bold">Code de réduction</div>
      </div>
      <div class="d-flex justify-space-between align-top sm-gap">
        <div>
          <div class="text-body-1">
            <button @click="remove_code_reduction()" class="text-dark-red" style="position: relative; top: -1px"><v-icon
                icon="mdi-delete-outline"></v-icon></button>
            Code <b>{{ inscription.code_reduction.nom }}</b>
          </div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="codeReductionPrixAffichable !== null">{{ codeReductionPrixAffichable }}€</span><span v-else>-</span>
        </div>
      </div>
    </div>

    <v-dialog v-model="showDialogCodeReduction" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <p>Si vous possédez un code de réduction, vous pouvez l'entrer ici. Il sera appliqué à cette inscription.
          </p>
          <v-row>
            <v-col>
              <v-text-field label="Code de réduction" v-model="code_reduction.nom" dense outlined></v-text-field>
              <v-btn color="dark-green" block @click="checkValidityCode()">Appliquer</v-btn>
              <v-alert variant="tonal" color="error" v-if="!code_valid" class="mt-2">Ce code de réduction n'est pas
                valide, a expiré ou son nombre d'utilisation est atteint</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialogCodeReduction = false">Abandonner</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import Code_Reduction from "@/classes/Code_Reduction/Code_Reduction.class";
import CartCourseItem from "@/components/App/Shopping_Cart/Cart_Course_Item";
import CartPackCourseItem from "@/components/App/Shopping_Cart/Cart_Pack_Course_Item";
import CartOptionItem from "@/components/App/Shopping_Cart/Cart_Option_Item";
import CartActiviteItem from "@/components/App/Shopping_Cart/Cart_Activite_Item";
import CartArticleItem from "@/components/App/Shopping_Cart/Cart_Article_Item";
import CartLivraison from "@/components/App/Shopping_Cart/Cart_Livraison.vue";

export default {
  components: { CartCourseItem, CartPackCourseItem, CartOptionItem, CartActiviteItem, CartArticleItem, CartLivraison },
  props: ["item"],
  data() {
    return {
      inscription: {},
      showDialogCodeReduction: false,
      code_reduction: {},
      code_valid: true,
    };
  },

  computed: {
    ...mapStores(useMainStore, useBookingStore),
    has_remboursement() {
      let initial_commande = this.bookingStore.initial_commande_inscription;
      if (!initial_commande) return false;
      if (initial_commande.prix && parseFloat(initial_commande.prix) > 0) return parseFloat(initial_commande.prix);
      return false;
    },
    has_donation() {
      if (this.inscription.donation.actif && this.inscription.donation.montant > 0) {
        return true;
      }
      return false;
    },
    has_frais_bourse_dossard() {

      if (this.mainStore.dossard_bourse_mode && this.inscription.frais_bourse_dossard) {
        return true;
      }
      return false;
    },
    has_gia() {
      if (this.inscription.gia.propose && this.inscription.gia.selected) {
        return true;
      }
      return false;
    },
    has_alerte_sms() {
      if (this.inscription.alerte_sms.propose && this.inscription.alerte_sms.selected) {
        return true;
      }
      return false;
    },
    has_parcours_not_in_pack() {
      if (!this.inscription.list_courses || !this.inscription.list_courses.list) {
        return false;
      }

      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].selected && this.is_not_in_selected_pack(this.inscription.list_courses.list[i].id)) {
          return true;
        }
      }
      return false;
    },
    has_options() {
      if (!this.inscription.list_options) {
        return false;
      }
      for (let i = 0; i < this.inscription.list_options.list.length; i++) {
        if (parseInt(this.inscription.list_options.list[i].quantite_souhaite) > 0) {
          return true;
        }
      }
      return false;
    },
    has_activites() {
      if (!this.inscription.list_activites) {
        return false;
      }
      for (let i = 0; i < this.inscription.list_activites.list.length; i++) {
        if (parseInt(this.inscription.list_activites.list[i].quantite_souhaite) > 0) {
          return true;
        }
      }
      return false;
    },
    has_articles() {
      if (!this.inscription.list_articles) {
        return false;
      }
      for (let i = 0; i < this.inscription.list_articles.list.length; i++) {
        if (parseInt(this.inscription.list_articles.list[i].quantite_souhaite) > 0) {
          return true;
        }
      }
      return false;
    },
    has_pack() {
      if (!this.inscription.list_packs_courses || !this.inscription.list_packs_courses.list) {
        return false;
      }

      for (let i = 0; i < this.inscription.list_packs_courses.list.length; i++) {
        if (this.inscription.list_packs_courses.list[i].selected) {
          return true;
        }
      }
      return false;
    },
    /** Montant négatif uniquement si une réduction est réellement appliquée (ex. pas { nb_articles: 1, prix: 0 }). */
    codeReductionPrixAffichable() {
      const p = parseFloat(this.inscription?.code_reduction?.cart?.prix);
      if (Number.isNaN(p) || p >= 0) return null;
      return p;
    },
  },
  methods: {
    openDialogCodeReduction() {
      this.showDialogCodeReduction = true;
      this.code_reduction = new Code_Reduction();
      this.code_reduction.id_module = this.mainStore.module.id;
    },
    async checkValidityCode() {
      this.code_valid = true;
      await this.code_reduction.fetch_by_name();
      if (!this.code_reduction.id) {
        this.code_valid = false;
        return;
      }
      const nb_local_usage = this.bookingStore.get_nb_usage_code_reduction(this.code_reduction.id);
      const remaining_usage = this.code_reduction.is_remaining_usage(nb_local_usage);
      if (remaining_usage) {
        this.inscription.apply_code_reduction(this.code_reduction);
        this.bookingStore.compute_cart();
        this.showDialogCodeReduction = false;
        return;
      }
      this.code_valid = false;

    },
    async remove_code_reduction() {
      await this.inscription.remove_code_reduction();
      this.bookingStore.compute_cart();
    },

    is_not_in_selected_pack(id) {
      if (!this.inscription.list_packs_courses || !this.inscription.list_packs_courses.list) {
        return true;
      }

      for (let i = 0; i < this.inscription.list_packs_courses.list.length; i++) {
        if (this.inscription.list_packs_courses.list[i].selected) {
          let pack = this.inscription.list_packs_courses.list[i];
          for (let j = 0; j < pack.list_liaisons.length; j++) {
            if (pack.list_liaisons[j].id_course == id) {
              return false;
            }
          }
        }
      }
      return true;
    },
  },
  created() {
    this.inscription = this.item;
  },
};
</script>

<style lang="scss">
#shopping_cart hr.v-divider {
  margin: 5px 0 !important;
}
</style>